import React, { Component } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

export default class FluencyLetterT extends Component {
  render() {
    var {
      fluency_lt_score,
      fluecy_letter_t_stop_watch_1,
      noOfWords1,
      flu_t_part_1_note,
      fluecy_letter_t_stop_watch_2,
      letter_t_fluency_type,
      fluency_lt_score,
      fluency_lt_no_of_correct_words,
      fluency_letter_t_words,
    } = this.props.data;
    let no_of_words = fluency_letter_t_words
      ? JSON.parse(fluency_letter_t_words)
      : [];
    let total_spoken =
      (60 -
        (fluecy_letter_t_stop_watch_2 == 60
          ? 0
          : Number(60 - fluecy_letter_t_stop_watch_2))) /
      parseFloat(fluency_lt_no_of_correct_words);
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-10" style={{ paddingTop: 30 }}>
        </div>
        <div className="col-lg-2 pt-4" style={{ borderLeft: "1px solid #000" }}>
          <div>
            <br />
            <br />
            <span className="fs-19">Score (0 - 12) </span>
            <input
              type="number"
              name="fluency_lt_score"
              value={fluency_lt_score}
              readOnly
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
